const Actions = {
  Navigate: {
    DO: 'v.employees.actions.navigate.do'
  },
  Tabs: {
    OPEN: 'v.employees.actions.tabs.open',
    CLOSE: 'v.employees.actions.tabs.close',

    OPEN_NEW: 'v.employees.actions.tab.open-new'
  },
  Details: {
    OPEN: 'v.employees.actions.details.open'
  },
  New: {
    OPEN: 'v.employees.actions.new.open'
  },
  SwitchModal: {
    OPEN: 'v.employees.actions.switch-modal.open',
    CLOSE: 'v.employees.actions.switch-modal.close'
  },

  CHANGE_INDEX_FILTER: 'v.employees.actions.index-filters.change'
};

const Mutations = {
  CLEAR: 'v.employees.mutations.clear',
  ActiveView: {
    SET: 'v.employees.mutations.active-view.set'
  },
  Tabs: {
    ADD: 'v.employees.mutations.tabs.add',
    OPEN: 'v.employees.mutations.tabs.open',
    CLOSE: 'v.employees.mutations.tabs.close'
  },

  SwitchModal: {
    OPEN: 'v.employees.mutations.switch-modal.open',
    CLOSE: 'v.employees.mutations.switch-modal.close'
  },

  SET_INDEX_FILTER: 'v.employees.mutations.index-filter.set'
};

const Views = {
  Index: 'v.employees.views.index'
};

export default {
  Actions,
  Mutations,
  Views
};
